
import AppToolbar from '@/_components/bar/appToolbar/appToolbar.vue'
import ProjectMixin from '@/_mixins/project'
import { accessClient } from '@/apolloClient'
import { PROJECT_ACCESS_READERS_QUERY } from '@/views/Project/access/gql/queries.ts'
import { cloneDeep } from 'lodash'
import { Project } from '@/views/Project/access/types'

export default {
    name: 'AccessSettingsReaders',
    mixins: [ProjectMixin],
    components: {
        AppToolbar,
    },
    data() {
        return {
            isFetching: false,
            project: null as Maybe<Project>,
            allReadersForProject: [] as any[],
        }
    },
    methods: {
        async fetchReaders() {
            this.isFetching = true
            try {
                const accessControlResult = await accessClient.query({
                    query: PROJECT_ACCESS_READERS_QUERY,
                    variables: {
                        projectId: this.currentProjectId,
                    },
                    fetchPolicy: 'network-only',
                })

                this.allReadersForProject = cloneDeep(accessControlResult.data.allReadersForProject)
                this.project = accessControlResult.data.project
            } finally {
                this.isFetching = false
            }
        },
    },
    mounted() {
        this.fetchReaders()
    },
}
